interface IRaQFormContentWrapper {
  children: JSX.Element | JSX.Element[];
}

const RaQFormContentWrapper = ({
  children,
}: IRaQFormContentWrapper): JSX.Element => {
  return (
    <div className="mx-4 mt-4 flex flex-col desktop:mx-0 desktop:pt-0">
      {children}
    </div>
  );
};

export default RaQFormContentWrapper;
